import React, { useMemo } from "react";
import { ErrorMessage } from "formik";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../../designsystem/KC_Button/KC_Button";
import TestsID from "../../../../utils/TestsID";
import { tt } from "../../../../utils/i18n/i18n";

interface Props {
  displayErrors: boolean;
}

export default function (props: Props) {
  const errorContent = useMemo(() => {
    if (!props.displayErrors) {
      return null;
    }

    return (
      <div className="flex-grow-1">
        <ErrorMessage name="prizes" component="div" className="error px-4" />
        <ErrorMessage name="ctas">
          {(msg) =>
            typeof msg === "string" ? (
              <div className="error px-4">{msg}</div>
            ) : null
          }
        </ErrorMessage>
      </div>
    );
  }, [props.displayErrors]);

  return (
    <div
      id="bottom-buttons"
      className="p-4 d-flex flex-row align-items-center save-btn-container"
    >
      <div className="d-flex flex-column flex-grow-1">{errorContent}</div>
      <div className="d-flex justify-content-sm-end  formik-submit-button-container">
        <KC_Button
          id={TestsID.JP_FORM_SUBMIT_BTN}
          text={tt("save")}
          type={KC_ButtonType.Submit}
          isPrimary
          size={KC_ButtonSize.Large}
          className="formik-submit-button d-flex"
        />
      </div>
    </div>
  );
}
